import apiClient from "../config/apiClient";


export const fetchIvfHistory = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=patient/ivf?page=1&limit=15&patient_id=${id}&startDate=&endDate=`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  